import React, { Component } from 'react';



export default class Top extends Component{

	constructor(props){
		super(props);

		this.state = {
			data: props.data,
			config: props.config
		}


	}

	render(){

		var element = null;

		return (
			<section className="footer_top">
				{element}
			</section>

		);

	}

}


// WEBPACK FOOTER //
// ./src/Components/Footer/Top/index.js